module.exports = __webpack_public_path__ + "img/halfling_19.57f65c44.png";